import { getOption } from "../../Platform/Options/Options";

/**
 * Get the local cost for a product using outlet (use_global_cost) and vendor (use_average_cost) settings
 * @param product
 * @param {string?} outlet The Outlet to get the cost for (defaults to the current outlet)
 * @param {boolean?} forceLast Whether to force the product to use last cost (defaults to false)
 * @param {boolean?} useGlobalCost Whether to force the global cost
 * @returns {number} The local case cost for the product
 */
export function determineLocalCost(
    product: any,
    outlet?: null | string,
    forceLast = false,
    useGlobalCost: null | boolean = null
): number {
    const averageCost = getOption("cost_calculation_method") !== "last" && !forceLast;
    const outletId = typeof outlet === "undefined" ? getOption("outlet") : outlet;
    let globalCost = useGlobalCost === null ? getOption("outlet_use_global_cost") : useGlobalCost;

    if(
        useGlobalCost === null &&
        typeof outlet !== "undefined" &&
        outlet !== null &&
        outletId !== null &&
        getOption("outlet") !== outletId
    ) {
        globalCost = false;
    }

    // Check outlet costs first so that the global cost can be used as fallback
    if(!globalCost && outletId) {
        for(let i = 0, l = product.costs.length; i < l; i++) {
            if(product.costs[i].outlet_id === outletId) {
                if(averageCost) {
                    return parseFloat(product.costs[i].average_cost);
                } else {
                    return parseFloat(product.costs[i].last_cost);
                }
            }
        }
    }

    if(averageCost) {
        return parseFloat(product.average_cost);
    }

    if(forceLast) {
        return parseFloat(product.last_cost);
    }

    return parseFloat(product.cost);
}
